var map = {
	"./000-closed.png": 4571,
	"./000-opened.png": 8408,
	"./001-closed.png": 5324,
	"./001-opened.png": 1843,
	"./002-closed.png": 2157,
	"./002-opened.png": 7750,
	"./010-closed.png": 8078,
	"./010-opened.png": 8769,
	"./011-closed.png": 3885,
	"./011-opened.png": 7718,
	"./012-closed.png": 8204,
	"./012-opened.png": 7987,
	"./100-closed.png": 9476,
	"./100-opened.png": 4843,
	"./101-closed.png": 8899,
	"./101-opened.png": 64,
	"./102-closed.png": 4822,
	"./102-opened.png": 4329,
	"./110-closed.png": 97,
	"./110-opened.png": 7378,
	"./111-closed.png": 1026,
	"./111-opened.png": 6925,
	"./112-closed.png": 1183,
	"./112-opened.png": 6324,
	"./200-closed.png": 7741,
	"./200-opened.png": 9398,
	"./201-closed.png": 2961,
	"./201-opened.png": 4097,
	"./202-closed.png": 3611,
	"./202-opened.png": 1256,
	"./210-closed.png": 192,
	"./210-opened.png": 8399,
	"./211-closed.png": 1983,
	"./211-opened.png": 8948,
	"./212-closed.png": 7762,
	"./212-opened.png": 6813,
	"./mushroom-closed.png": 327,
	"./mushroom-opened.png": 668,
	"./rifle-closed.png": 6029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3029;